import UpdateCard from './UpdateCard'

export default UpdateCard
